import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../components/ui/PageWrapper';
import FadeUp from '../components/ui/FadeUp';
import CTASection from '../components/sections/CTASection';

const products = [
  { icon: '💎', title: 'Vastu Crystals', desc: 'Specific crystals to amplify positive vibrations and neutralise negative energies in your space.' },
  { icon: '🔯', title: 'Yantras', desc: 'Sacred geometric symbols to correct directional imbalances and enhance positive energy.' },
  { icon: '🧿', title: 'Vastu Symbols', desc: 'Authentic Vastu symbols and sacred geometry for specific directional corrections.' },
  { icon: '🔔', title: 'Wind Chimes & Bells', desc: 'Sound therapy tools to break stagnant energy and invite positive vibrations.' },
  { icon: '🌿', title: 'Vastu Plants', desc: 'Recommended plants for specific Vastu zones to enhance energy flow.' },
  { icon: '🪞', title: 'Vastu Mirrors', desc: 'Specially designed mirrors to redirect and amplify positive energy.' },
];

export default function Remedies() {
  return (
    <PageWrapper>
      <section style={{ paddingTop: 140, paddingBottom: 80, background: 'linear-gradient(135deg, #0D0D1F, #1A0F2E)', position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle at 60% 40%, rgba(201,84,122,0.06) 0%, transparent 60%)' }} />
        <div className="container">
          <FadeUp>
            <p className="section-eyebrow">Shop by Product</p>
            <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)' }}>Vastu Products</h1>
            <div className="divider" />
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 580, lineHeight: 1.8 }}>
              Authentic Vastu products to enhance positive energy in your home and workspace. Each product is recommended based on specific Vastu principles.
            </p>
          </FadeUp>
        </div>
      </section>

      <section style={{ padding: '80px 0', background: '#0D0D1F' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 24 }}>
            {products.map((r, i) => (
              <FadeUp key={i} delay={i * 0.08}>
                <div style={{
                  background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(232,135,26,0.1)',
                  borderRadius: 12, padding: '28px 24px', height: '100%'
                }}>
                  <p style={{ fontSize: 32, marginBottom: 14 }}>{r.icon}</p>
                  <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 10 }}>{r.title}</h3>
                  <p style={{ fontSize: 13, opacity: 0.65, lineHeight: 1.7 }}>{r.desc}</p>
                </div>
              </FadeUp>
            ))}
          </div>

          <FadeUp style={{ marginTop: 64, textAlign: 'center' }}>
            <p style={{ fontSize: 16, opacity: 0.7, maxWidth: 500, margin: '0 auto 32px', lineHeight: 1.8 }}>
              For detailed product catalogue and pricing, please get in touch with us.
            </p>
            <Link to="/contact" className="btn-primary" style={{ display: 'inline-block' }}>
              Enquire About Products
            </Link>
          </FadeUp>
        </div>
      </section>

      <CTASection />
    </PageWrapper>
  );
}
